module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="phx-tabs-'+
((__t=(id))==null?'':__t)+
'" class="phx-tabs-container">\n</div>';
}
return __p;
};
